import styled from "styled-components";
import {
  LayoutProps,
  layout,
  TypographyProps,
  typography,
} from "styled-system";
import { ModalEnlaceExterno, showModal } from "@bpba/ui-components";

type ResponseContainerProps = {
  respuesta: string;
  tabIndex?: number;
};

export function ResponseContainer({
  respuesta,
  tabIndex,
}: ResponseContainerProps) {
  /**
   * Se detecta el click en algún enlace dentro del contenedor de la respuesta.
   */

  async function clickResponse(event: React.MouseEvent<HTMLElement>) {
    event?.preventDefault();
    const selectedElement: any = event?.target;

    if (selectedElement && selectedElement.localName === "a") {
      const targetHref = selectedElement.href;
      const targetHost = selectedElement.host;
      const currentHost = window.location.host;

      if (currentHost !== targetHost) {
        targetHref &&
          showModal({ url: targetHref, ModalComponent: ModalEnlaceExterno });
      } else {
        navigateToUrl(targetHref);
      }
    }
  }
  // Se modifican los tabindex de los hipervínculos
  const respuestaModificada = respuesta?.replace(
    "<a",
    `<a tabindex="${tabIndex}"`
  );

  return (
    <Container
      dangerouslySetInnerHTML={{ __html: respuestaModificada }}
      onClick={clickResponse}
      tabIndex={tabIndex}
      lineHeight={[null, null, "21px"]}
    />
  );
}

const Container = styled.div<LayoutProps & TypographyProps>(
  layout,
  typography,
  (props) => ({
    a: {
      color: props.theme.colors.primary[0],
    },
  })
);

/** Abre url en la pestaña actual */
const navigateToUrl = (url: string | undefined) => {
  if (url) window.location.href = url;
};
